import { CIMSSingleColumn } from '../../../../../../../../../components/CIMSTable/CIMSColumn/types'
import { ConcreteTestSet } from '../../ConcreteTestSetTrackerContext'

export function breakDataFilter(
  callback: (record: ConcreteTestSet) => { complete: boolean }
): CIMSSingleColumn<ConcreteTestSet>['filter'] {
  return {
    type: 'boolean',
    with: 'callback',
    labels: { true: 'Complete', false: 'Missing' },
    onFilter: (value, record) => {
      const { complete } = callback(record)
      return !!value ? complete : !complete
    },
  }
}
